<template>
  <div class="fileCommunity" v-show="childFalse">
    <div class="topBox">
      <el-button @click="childback" type="">返回</el-button>
    </div>
    <div class="bottomBox">
      <el-card class="tree-card" :body-style="treeCard">
        <div class="basic">
          <div class="basicTitle">基本信息</div>
          <div class="basicItem">
            <span>社区名称:</span>
            <span>{{ communitylist.name }}</span>
          </div>
          <div class="basicItem">
            <span>所属街道:</span>
            <span>{{ communitylist.levelName }}</span>
          </div>
          <div class="basicItem">
            <span>经纬度:</span>
            <span
              >{{ communitylist.latitude }},{{ communitylist.longitude }}</span
            >
          </div>
          <!--  -->
        </div>
      </el-card>
      <div class="rightcenter">
        <commentright
          :dialogCount="communitylist"
          :showType="showType"
        ></commentright>
      </div>
    </div>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  watch
} from 'vue';
import commentright from './commentright';
import { regionInfo } from '@/api/system/region.js';
export default defineComponent({
  name: '',
  components: { commentright },
  props: {
    grandsonVisible: {
      type: Boolean
    },
    showType: {
      type: String
    },
    prisonId: {
      type: Number
    }
  },
  setup(props, context) {
    const data = reactive({
      treeCard: {
        height: '100%',
        display: "flex",
        flexDirection: "column"
      },
      childFalse: false,
      prisonIds: 0,
      communitylist: {}
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.childFalse = props.grandsonVisible;
    });
    watchEffect(() => {
      context.emit('update:grandsonVisible', data.childFalse);
    });
    watch(() => props.prisonId, (v) => {
      data.prisonIds = v;
      community();
    });
    const community = async() => {
      if (props.showType === '5') {
        const res = await regionInfo(data.prisonIds);
        data.communitylist = res.regionInfo;
        // const aa = data.communitylist.levelName;
        // aa.split("/");
      }
    };
    const childback = () => {
      data.childFalse = false;
    };

    return {
      ...refData,
      childback
    };
  }
});
</script>
<style  lang='scss' scoped >
.rightcenter {
  flex: 1;
}
.fileCommunity {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  .topBox {
    line-height: 66px;
    border-bottom: 1px solid #f1f2f5;
    padding: 0 20px;
  }
  .bottomBox {
    display: flex;
    flex: 1;
    overflow: auto;
  }
  .tree-card {
    height: 100%;
    width: 400px;
  }
  .basic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    .basicTitle {
      color: #000;
      line-height: 40px;
      font-weight: bold;
    }
    .basicImgbox {
      width: 100%;
      height: 160px;
      display: flex;
      .basicImg {
        width: 110px;
        height: 100%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .basicName {
        flex: 1;
      }
    }
    .basicItem {
      flex: 1;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f1f2f5;
      padding: 10px 0;
      line-height: 24px;
      span {
        // width: 206px;
      }
    }
  }
  .center-card {
    flex: 1;
    position: relative;
    .centerbg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 386px;
      height: 386px;
      img {
        width: 100%;
        height: 100%;
      }
      .imgone {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgtwo {
        width: 75%;
        height: 75%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgthree {
        width: 50%;
        height: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: url('~@/assets/images/threeSolid/threecor.png');
        background-size: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
    }
    .centerbtn {
      width: 386px;
      height: 386px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .btnitem {
        width: 66px;
        height: 66px;
        text-align: center;
        line-height: 66px;
        border-radius: 100%;
        color: #fff;
        background: #388ff3;
        position: absolute;
        cursor: pointer;
        &:nth-child(1) {
          left: 50%;
          top: -30px;
        }
        &:nth-child(2) {
          left: 75%;
          top: 30px;
        }
        &:nth-child(3) {
          left: 90%;
          top: 50%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 83%;
        }
        &:nth-child(5) {
          left: 35%;
          bottom: -27px;
        }
        &:nth-child(6) {
          left: 20%;
          bottom: 61px;
          width: 45px;
          height: 45px;
          line-height: 42px;
        }
        &:nth-child(7) {
          left: -3%;
          bottom: 24%;
        }
        &:nth-child(8) {
          left: -1%;
          top: 110px;
        }
        &:nth-child(9) {
          left: 10%;
          top: 0px;
        }
      }
    }
  }
}
</style>